function NodeThread() {
    this.Identifier = "";
    this.Title = "";
    this.SubTitle = "";
    this.IconUrl = "User.png";
    this.Id = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = NodeThread;
}